<template>
  <el-dialog
    title="回访工单"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose">
    <el-form :model="appraiseRepairInfo" label-width="120px">
      <el-form-item label="回访建议">
        <el-input
          type="textarea"
          :rows="3"
          placeholder="必填，请填写回访建议"
          v-model="appraiseRepairInfo.context">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="_appraiseRepairInfo">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { appraiseRepair } from '@/api/housekeeping/housekeepingDispatchManageApi'

export default {
  name: 'AppraiseHousekeeping',
  data() {
    return {
      dialogVisible: false,
      appraiseRepairInfo: {
        repairId: '',
        repairType: '',
        context: '',
        publicArea: '',
        repairChannel: '',
        maintenanceType: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(repair) {
      this.appraiseRepairInfo = {
        ...this.appraiseRepairInfo,
        repairType: repair.repairType,
        repairId: repair.repairId,
        publicArea: repair.publicArea,
        repairChannel: repair.repairChannel,
        maintenanceType: repair.maintenanceType,
        shopId: getShopId()
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.clearAppraiseRepairInfo()
    },
    appraiseRepairValidate() {
      if (!this.appraiseRepairInfo.repairId) {
        this.$message.error('报修单不能为空')
        return false
      }
      
      if (!this.appraiseRepairInfo.context) {
        this.$message.error('回访建议不能为空')
        return false
      }
      
      return true
    },
    async _appraiseRepairInfo() {
      if (!this.appraiseRepairValidate()) {
        return
      }
      
      try {
        const res = await appraiseRepair(this.appraiseRepairInfo)
        if (res.code === 0) {
          this.$message.success('操作成功')
          this.handleClose()
          this.$emit('appraise-success')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error('操作失败')
      }
    },
    clearAppraiseRepairInfo() {
      this.appraiseRepairInfo = {
        repairId: '',
        repairType: '',
        context: '',
        publicArea: '',
        repairChannel: '',
        maintenanceType: '',
        shopId: ''
      }
    }
  }
}
</script>